import { createStore } from "owa-satcheljs";
import type { IrisCampaignDialogState } from "./schema/irisCampaignDialogState";

export const getIrisCampaignDialogStore: () => IrisCampaignDialogState = createStore<IrisCampaignDialogState>("irisCampaignDialogState", {
    accountKey: undefined,
    requestId: 0,
    viewState: "idle",
    dialog: undefined,
    impressionLogged: false,
});
